import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fmt = (n) =>
  new Intl.NumberFormat("it-IT", { maximumFractionDigits: 0 }).format(Math.round(n || 0));

export const mediaUrl = (url) =>
  !url ? null : url.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`;

export const uploadItemImage = (token, id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios
    .post(`${API}/admin/items/${id}/image`, fd, { headers: { "X-Admin-Token": token } })
    .then((r) => r.data);
};

export const getZoneImages = (all = false) =>
  axios.get(`${API}/zone-images${all ? "?all=1" : ""}`).then((r) => r.data);

export const aiSuggest = (description, zone) =>
  axios.post(`${API}/ai/suggest`, { description, zone }).then((r) => r.data);

export const adminAiRules = (token) =>
  axios.get(`${API}/admin/ai-rules`, auth(token)).then((r) => r.data);
export const adminCreateAiRule = (token, text) =>
  axios.post(`${API}/admin/ai-rules`, { text }, auth(token)).then((r) => r.data);
export const adminUpdateAiRule = (token, id, text) =>
  axios.put(`${API}/admin/ai-rules/${id}`, { text }, auth(token)).then((r) => r.data);
export const adminDeleteAiRule = (token, id) =>
  axios.delete(`${API}/admin/ai-rules/${id}`, auth(token)).then((r) => r.data);

export const uploadZoneImage = (token, type, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios
    .post(`${API}/admin/zone-images/image?type=${encodeURIComponent(type)}`, fd, {
      headers: { "X-Admin-Token": token },
    })
    .then((r) => r.data);
};

export const getCatalog = () => axios.get(`${API}/catalog`).then((r) => r.data);

export const adminCatalog = (token) =>
  axios.get(`${API}/admin/catalog`, { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const createQuote = (payload) => axios.post(`${API}/quotes`, payload).then((r) => r.data);

export const sendQuote = (id) => axios.post(`${API}/quotes/${id}/send`).then((r) => r.data);

const auth = (token) => ({ headers: { "X-Admin-Token": token } });

export const adminLogin = (token) =>
  axios.post(`${API}/admin/login`, { token }).then((r) => r.data);
export const adminCreateItem = (token, body) =>
  axios.post(`${API}/admin/items`, body, auth(token)).then((r) => r.data);
export const adminUpdateItem = (token, id, body) =>
  axios.put(`${API}/admin/items/${id}`, body, auth(token)).then((r) => r.data);
export const adminDeleteItem = (token, id) =>
  axios.delete(`${API}/admin/items/${id}`, auth(token)).then((r) => r.data);
export const adminQuotes = (token) =>
  axios.get(`${API}/admin/quotes`, auth(token)).then((r) => r.data);
export const adminDeleteQuote = (token, id) =>
  axios.delete(`${API}/admin/quotes/${id}`, auth(token)).then((r) => r.data);

export const adminCreateCategory = (token, name) =>
  axios.post(`${API}/admin/categories`, { name }, auth(token)).then((r) => r.data);
export const adminUpdateCategory = (token, key, body) =>
  axios.put(`${API}/admin/categories/${key}`, body, auth(token)).then((r) => r.data);
export const adminDeleteCategory = (token, key) =>
  axios.delete(`${API}/admin/categories/${key}`, auth(token)).then((r) => r.data);
export const adminReorderCategories = (token, keys) =>
  axios.post(`${API}/admin/categories/reorder`, { keys }, auth(token)).then((r) => r.data);

export const adminSetZoneImage = (token, type, image_url) =>
  axios.put(`${API}/admin/zone-images`, { type, image_url }, auth(token)).then((r) => r.data);
export const adminDeleteZoneImage = (token, type) =>
  axios
    .delete(`${API}/admin/zone-images?type=${encodeURIComponent(type)}`, auth(token))
    .then((r) => r.data);
